import React, { useEffect, useRef, useState } from 'react';
import { getAllCategories, getAllCountries, updateEvent, getEventBySlug } from '../../api';
import EditEventTab from './EditEventTab';
import { useParams } from 'react-router-dom';
import Background from '../Login/Background';
import PageHeader from '../../components/common/PageHeader/PageHeader';

type CreateVenueEventProps = {};

const EditEvent = (props: CreateVenueEventProps) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [categories, setCategories] = useState([]);
    const [countries, setCountries] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [eventId, setEventId] = useState(null);
    const [tickets, setTickets] = useState([]);
    const [eventSlug, setEventSlug] = useState('new-event');
    const [event, setEvent] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const params = useParams();
    const slugId = params.slugId || '';
    const [formData, setFormData] = useState({
      eventId: 0,
      eventName: "",
      eventDate: "",
      endDate: "",
      isSingleDayEvent: false,
      eventTime: "",
      endTime:"",
      eventDuration: "",
      thumbImg: "",
      eventDescription: "",
      eventVenue: "",
      venueName: "",
      eventAddress1: "",
      eventAddress2: "",
      eventCountry: 0,
      eventState: "",
      eventCity: "",
      eventZip: "",
      categoryId: 0,
      ticketType: "",
      eventType: "",
      onlineEventType: "",
      eventStatus: "active",
      eventLocation: "",
      shortDescription: "",
      isPreRegistrationRequired: false,
      hasTermsAndConditions: false,
      termsAndConditions: "",
      isOtherAttendeeRequired: false,
      ticketImage: "",
      latitude: 0,
      longitude: 0,
      hasMultipleVenues: false,
    });

    useEffect(() => {
        const fetchCategory = async () => {
            const res = await getAllCategories();
            const categoryOption = res.map((category: any) => ({
                value: category.categoryId,
                label: category.categoryName,
            }));
            setCategories(categoryOption);
        };
        const fetchCountry = async () => {
            const res = await getAllCountries();
            const countryOption = res.map((country: any) => ({
                value: country.countryId,
                label: country.countryName,
            }));
            setCountries(countryOption);
        };  
        const fetchEvent = async () => {
            try {
              setIsLoading(true);
              const storedEvent = localStorage.getItem("eventData");
              if (!storedEvent) return;
              const parsed = JSON.parse(storedEvent);
              const slugId = parsed.slugId;
              if (!slugId) return;
              const res = await getEventBySlug(slugId);
              const event = res[0];
              setEvent(event);
              setEventId(event.eventId);
              setEventSlug(event.slugId || slugId);

              setFormData({
                eventId: event.eventId || 0,
                eventName: event.eventName || '',
                eventDate: event.eventDate || '',
                endDate: event.endDate || event.eventDate,
                isSingleDayEvent: event.isSingleDayEvent === true || event.isSingleDayEvent === 'true' || event.isSameDayEvent === true || event.isSameDayEvent === 'true' || event.isSameDayEvent === 1 || (!event.endDate || event.eventDate === event.endDate),
                eventTime: event.eventTime || '',
                endTime:event.endTime||'',
                eventDuration: event.eventDuration || '',
                thumbImg: event.thumbImg || '',
                eventDescription: event.eventDescription || '',
                eventLocation: event.eventLocation || '',
                shortDescription: event.shortDescription || '',
                eventType: event.eventType || '',
                eventStatus: event.eventStatus || 'active',
                eventVenue: event.eventVenue || '',
                venueName: event.locationData?.[0]?.venueName || event.eventVenue || '',
                eventAddress1: event.eventAddress1 || '',
                eventAddress2: event.eventAddress2 || '',
                eventCountry: event.eventCountry || 0,
                eventState: event.eventState || '',
                eventCity: event.eventCity || '',
                eventZip: event.eventZip || '',
                categoryId: event.categoryId || 0,
                ticketType: event.ticketType || '',
                onlineEventType: event.onlineEventType || '',
                isPreRegistrationRequired: event.isPreRegistrationRequired || false,
                hasTermsAndConditions: event.hasTermsAndConditions || false,
                termsAndConditions: event.termsAndConditions || '',
                isOtherAttendeeRequired: event.isOtherAttendeeRequired || false,
                ticketImage: event.ticketImage || '',
                latitude: event.latitude || 0,
                longitude: event.longitude || 0,
                hasMultipleVenues: event.hasMultipleVenues || false,
              });
            } catch (error) {
              console.error('Failed to fetch event:', error);
            } finally {
              setIsLoading(false);
            }
          };
          fetchCategory();
          fetchCountry();
          fetchEvent();
        }, []);

    const handleChange = (e: { target: { name: any; value: any; }; }) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const onSelectChange = (data: any, key: string) => {
        setFormData(prevState => ({
            ...prevState,
            [key]: data.value,
        }));
    };
    
    const onCheckboxChange = (key: string, checked: boolean) => {
        setFormData(prevState => ({
            ...prevState,
            [key]: checked,
        }));
    };

    const handleThumbBtnClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (event: any) => {
        if (event.target.files && event.target.files.length > 0) {
          const file = event.target.files[0];
          setSelectedFile(file);
        }
      };

    return (
      <>
        <style>{`
          /* Default to Light Mode */
          .glass-panel {
            --v3-text-main: #0f172a;
            --v3-text-muted: #64748b;
            --v3-text-faint: #94a3b8;
            --v3-bg-subtle: #f8fafc;
            --v3-bg-hover: #f1f5f9;
            --v3-border-subtle: #e2e8f0;
            --v3-border-medium: #cbd5e1;
          }
          
          /* Night Mode Overrides */
          html.night-mode .glass-panel,
          .night-mode .glass-panel {
            --v3-text-main: #ffffff;
            --v3-text-muted: rgba(255,255,255,0.5);
            --v3-text-faint: rgba(255,255,255,0.4);
            --v3-bg-subtle: rgba(255,255,255,0.02);
            --v3-bg-hover: rgba(255,255,255,0.04);
            --v3-border-subtle: rgba(255,255,255,0.05);
            --v3-border-medium: rgba(255,255,255,0.1);
          }
          
          html:not(.night-mode) .v3-poster-box {
             background: var(--v3-bg-hover) !important;
             border-color: var(--v3-border-medium) !important;
          }
        `}</style>
        <Background />
        <div style={{ position: 'relative', zIndex: 1, padding: '24px 0', minHeight: '100vh' }}>
          <div className="container" style={{ maxWidth: 1000, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 24 }}>
            <PageHeader 
              title="Edit Event" 
              subtitle="Update event details, timing, banner images, and booking preferences."
              isLoading={isLoading}
            />

            <EditEventTab
              formData={formData}
              handleChange={handleChange}
              onSelectChange={onSelectChange}
              onCheckboxChange={onCheckboxChange}
              selectedFile={selectedFile}
              handleThumbBtnClick={handleThumbBtnClick}
              fileInputRef={fileInputRef}
              handleFileChange={handleFileChange}
              countries={countries} 
              categories={categories} 
            />
          </div>
        </div>
      </>
    );
};

export default EditEvent;